import { useEffect, useState } from 'react';
import { ChatLinkTarget, ChatTextSegment, findChatLinksInText } from '../../utils/chatLinkCorpus';

function plainTextSegments(text: string): ChatTextSegment[] {
  return [{ type: 'text', value: text }];
}

/**
 * Scan one message against the cached corpus when messageId, text, or corpus changes.
 * Does not fetch corpus — caller supplies the conversation-level whitelist.
 */
export default function useScannedChatMessageSegments(
  messageId: string,
  text: string,
  corpus: ChatLinkTarget[] | null,
): ChatTextSegment[] {
  const [segments, setSegments] = useState<ChatTextSegment[]>(() => plainTextSegments(text));

  useEffect(() => {
    if (!corpus || corpus.length === 0) {
      setSegments(plainTextSegments(text));
      return;
    }
    setSegments(findChatLinksInText(text, corpus));
  }, [messageId, text, corpus]);

  return segments;
}
